module.exports = __webpack_public_path__ + "static/media/TwitterActive@33x.66819ca7.png";